import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import usePendingHandler from '@shared/usePendingHandler';
import {diApi} from '@di-shared/api/di';
import useApiError from '@di-shared/features/common/useApiError';
import {AgreeInfo} from '@di-shared/api/di/__generated';

export interface UbiWithdrawBottomSheetProps {
  vin: string;
  serviceId: string;
  agreeInfo: Array<AgreeInfo>;
}

function UbiWithdrawBottomSheet({vin, serviceId, agreeInfo}: UbiWithdrawBottomSheetProps) {
  const {t} = useInferableTranslation();
  const {resolveError} = useApiError();

  const [submitWithdrawUbi] = usePendingHandler(
    async () => {
      await diApi.ubiThirdPartyAgreementsController.deleteCciAgreements({
        requestBody: {
          vin,
          serviceId,
          agreeInfo,
        },
      });
      window.bottomSheetClose(true);
    },
    async (error) => {
      await resolveError(error);
    }
  );

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2
          className="bottom_sheet_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T20121')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20122')}</strong>
        </div>
        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('T20119')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => submitWithdrawUbi()}
          >
            {t('T20123')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UbiWithdrawBottomSheet;
